import { useState } from 'react'
import { workProjects, labProjects } from '../../data/projects'
import ProjectModal from '../ProjectModal'
import './index.scss'

const domain = url => {
  try {
    return new URL(url).host.replace(/^www\./, '')
  } catch {
    return ''
  }
}

const ProjectCard = ({ project: p, onOpen }) => (
  <div className='pc-root' onClick={onOpen}>
    <div className='pc-image'>
      {p.image ? (
        <img src={p.image} alt={p.title} className='pc-image__img' />
      ) : (
        <span className='pc-image__placeholder'>{p.title}</span>
      )}
    </div>

    <div className='pc-title-row'>
      <div className='pc-title'>{p.title}</div>
      <div className='pc-tags'>
        {p.tags.map(t => (
          <span key={t} className='pc-tag'>
            {t}
          </span>
        ))}
      </div>
    </div>

    <div className='pc-client'>{p.client}</div>
    <div className='pc-desc'>{p.description}</div>

    <div className='pc-spacer' />

    <a
      className='pc-cta'
      href={p.live}
      target='_blank'
      rel='noopener noreferrer'
      onClick={e => e.stopPropagation()}>
      <span className='pc-cta__label'>Visit site</span>
      <span className='pc-cta__domain'>{domain(p.live)}</span>
    </a>

    {p.github ? (
      <a
        className='pc-github'
        href={p.github}
        target='_blank'
        rel='noopener noreferrer'
        onClick={e => e.stopPropagation()}>
        ↗ Source on GitHub
      </a>
    ) : (
      <div className='pc-github pc-github--empty' />
    )}
  </div>
)

const ProjectsPage = ({ mode }) => {
  const isLab = mode === 'lab'
  const projects = isLab ? labProjects : workProjects
  const [openProject, setOpenProject] = useState(null)

  return (
    <div className='pp-root'>
      <div className='pp-intro'>
        {isLab ? (
          <>
            <span className='pp-intro__bright'>
              This is the Lab — where curiosity turns into projects.
            </span>{' '}
            <span className='pp-intro__ul'>AI experiments</span>,{' '}
            <span className='pp-intro__ul'>games</span>,{' '}
            <span className='pp-intro__ul'>hackathon builds</span>, and{' '}
            <span className='pp-intro__ul'>side projects</span> that started as "this should only
            take a few hours."
          </>
        ) : (
          <>
            <span className='pp-intro__bright'>
              Hi, I'm Adam — an engineer with an entrepreneurial mindset and a designer's eye.
            </span>{' '}
            From enterprise <span className='pp-intro__ul'>Shopify stores</span> to{' '}
            <span className='pp-intro__ul'>healthcare integrations</span> and{' '}
            <span className='pp-intro__ul'>internal tools</span>, I enjoy turning ideas into
            products people actually use.
          </>
        )}
      </div>

      <div className='pp-grid'>
        {projects.map(p => (
          <ProjectCard key={p.title} project={p} onOpen={() => setOpenProject(p)} />
        ))}
      </div>

      {openProject && <ProjectModal project={openProject} onClose={() => setOpenProject(null)} />}
    </div>
  )
}

export default ProjectsPage
